module.exports = __webpack_public_path__ + "assets/img/page5-design-base-7ccd29c7.jpg";